import { Router,NavigationExtras} from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  newsearchArray:any;
  serch_product_list_home:any;
  searchInput:any=''
  constructor(public router:Router , public restApi:DataService) { }

  ngOnInit() {}
  ionViewWillEnter(){
  
    this.restApi.get_all_product().subscribe((data:any)=>{
        this.newsearchArray=data.searchpro;
    },(error:any)=>{
  
    })
  }

  setItems() {
    this.serch_product_list_home=this.newsearchArray;// here store the json response  we get from server.
    //console.log(this.serch_product_list_home.length)
  }
  getItems(ev) {
    // Reset items back to all of the items
     var val = ev.target.value;
     console.log(val)
    this.setItems();
    // set val to the value of the ev target
    console.log(val)
    console.log(this.serch_product_list_home.length)
    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
  
      this.serch_product_list_home = this.serch_product_list_home.filter((item) => {
        return (item.product_name.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  
  }
   
  goto_product_details(item){
    let product_id=item.product_id
    let navigationExtras: NavigationExtras = {
      queryParams: {
        product_id: JSON.stringify(product_id),
      }
    };
    console.log(item.product_id);
    //routerLink="/productdetails"
    this.router.navigate(['/productdetails'], navigationExtras); 
  }
  home(){
    this.router.navigateByUrl('/home')
  }
  search(){
    this.router.navigateByUrl('/search')
  }
  products(){
    this.router.navigateByUrl('/products')
  }
  editprofile(){
    this.router.navigateByUrl('/home')
  }
  wallet(){
    this.router.navigateByUrl('/wallet')
  }
  
}
